import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export interface User {
  id: string;
  name: string;
  avatar?: string;
}

interface UserGreetingProps {
  user: User;
  message: string;
}

const UserGreeting = ({ user, message }: UserGreetingProps) => {
  return (
    <div className="flex items-center justify-between px-6 py-4">
      <div>
        <h1 className="text-xl font-semibold text-time-display">
          Hey {user.name}!
        </h1>
        <p className="text-sm text-time-secondary">
          {message}
        </p>
      </div>
      {/* <Avatar className="w-12 h-12 shadow-soft">
        <AvatarImage src={user.avatar || "/placeholder.svg"} alt={user.name} />
        <AvatarFallback className="bg-primary text-primary-foreground font-semibold">
          {user.name.charAt(0).toUpperCase()}
        </AvatarFallback>
      </Avatar> */}
    </div>
  );
};

export default UserGreeting;